import { type AllProductDTO } from '@cart-services/types'
import { Amount } from '@cart-ui/Amount/Amount'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { HStack } from '@pets-ui/HStack/HStack'
import { CartOutlined } from '@pets-ui/icons'
import { Image } from '@pets-ui/Image/Image'
import { Skeleton } from '@pets-ui/Skeleton/Skeleton'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { useMemo } from 'react'

const IMAGE_SIZE = 131

interface NewProductCardProps {
  product: AllProductDTO
  onSelectProduct: (product: AllProductDTO) => void
}

export const NewProductCard = (props: NewProductCardProps) => {
  const { product, onSelectProduct } = props
  const minPrice = useMemo(() => product.variations.reduce(
    (min, variation) => Math.min(min, variation.sale_price),
    product.variations[0]?.sale_price ?? 0,
  ), [product.variations])

  const handleSelectProduct = () => {
    onSelectProduct(product)
  }

  return (
    <HStack
      backgroundColor={colors.white}
      borderWidth={1}
      borderStyle="solid"
      borderColor={colors.grey200}
      borderRadius={4}
      overflow="hidden"
    >
      {/* 左側商品圖 + new 角標 */}
      <Box position="relative" flexShrink={0} width={IMAGE_SIZE} height={IMAGE_SIZE} overflow="hidden">
        <Box position="absolute" right="50%" left={0} backgroundColor={colors.violet600} transform="rotate(-45deg) translate(-25%, -50%)" zIndex={1}>
          <Text align="center" fontSize={16} color={colors.white}>new</Text>
        </Box>
        <Image
          src={product.last_gallery_image || product.thumbnail}
          alt={product.title}
          width={IMAGE_SIZE}
          height={IMAGE_SIZE}
          objectFit="cover"
          loading="lazy"
          loadingFallback={<Skeleton width={IMAGE_SIZE} height={IMAGE_SIZE} />}
        />
      </Box>
      <VStack flex={1} px={2} py={3} gap={1}>
        <Box minHeight="40px">
          <Text lineClamp={2} color={colors.grey900}>
            {product.title}
          </Text>
        </Box>
        <Amount amount={minPrice} color={colors.red600} isBold />
        <Button
          width="fit-content"
          variant="filled"
          color="red"
          size="small"
          startIcon={<CartOutlined />}
          onClick={handleSelectProduct}
        >
          加入購物車
        </Button>
      </VStack>
    </HStack>
  )
}
